import { filterPanelsList } from 'common/api/v1/panelsCatalog';

import {
    FETCH_PANELS,
    FETCH_PANELS_FAILURE,
    FETCH_PANELS_SUCCESS,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default (brandName) => (dispatch) => {
    dispatch(createProposalModalActions[FETCH_PANELS]());

    filterPanelsList(brandName)
        .then((response) =>
            dispatch(
                createProposalModalActions[FETCH_PANELS_SUCCESS](
                    response?.data?.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(createProposalModalActions[FETCH_PANELS_FAILURE](error)),
        );
};
